import styles from "./index.module.scss";
import PortfolioLoadingDots from "./PortfolioLoadingDots";

export default function PortfolioStatValue({ value, isLoading }) {
  if (isLoading) {
    return (
      <p className={styles.portfolioStatValue} aria-busy="true" aria-label="Loading">
        <PortfolioLoadingDots />
      </p>
    );
  }

  return <p className={styles.portfolioStatValue}>{value}</p>;
}
